import { Button, Tooltip } from '@mui/material';
import React, { useState } from 'react'
import ModalArchivo from '../Components/Alertas/ModalArchivo';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SimCardDownloadRoundedIcon from '@mui/icons-material/SimCardDownloadRounded';

const ExportarArchivo = (props) => {

  const {lineas, nodos} = props;

  const [workSpace, setWorkSpace] = useState([]);
  const [nombreArchivo, setNombreArchivo] = useState('Archivo');

  const [abrirModal, setAbrirModal] = useState(false);
  const handleClose = () => setAbrirModal(false);
    
  const exportData = (e) => {
    e.preventDefault();
    setAbrirModal(false);
    workSpace.push(lineas);
    workSpace.push(nodos);

    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
    JSON.stringify(workSpace)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = nombreArchivo+".json";
        
    link.click();
    setWorkSpace([])
    setNombreArchivo('Archivo');
  };

  return (
    <>
    { abrirModal &&(
      <ModalArchivo 
        abrirModal={abrirModal} 
        setAbrirModal={setAbrirModal} 
        handleClose={handleClose} 
        exportData={exportData}
        setNombreArchivo={setNombreArchivo}
      />
      )}
      <Tooltip title='Exportar como JSON' >
        {/* Cambiar variant a 'outlined' para volver a activar funcionalidad */}
        <Button onClick={(e)=>{setAbrirModal(true)}} variant="disabled">
          <SimCardDownloadRoundedIcon/>
        </Button>
      </Tooltip>
    </>
  )
}

export default ExportarArchivo
